import { Button, Tooltip } from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import React, { useEffect, useState } from "react";
import { shallowEqual, useSelector } from "react-redux";
import {
	Card,
	CardBody,
	CardHeader,
	CardHeaderToolbar,
} from "../../../../_metronic/_partials/controls";
import {
	deleteOperarioCategory,
	getOperarioCategories,
	postOperarioCategory,
	updateOperarioCategory,
} from "../../../../api/operarioCategory";
import { alertError, alertSuccess } from "../../../../utils/logger";
import ConfirmDialog from "../../../components/dialogs/ConfirmDialog";
import EditOperarioCategoryDialog from "../../../components/dialogs/EditOperarioCategoryDialog";
import Table, { buttonsStyle } from "../../../components/tables/table";

function getData(categories) {
	return categories.map((category) => ({
		descripcion: category?.descripcion,
		id: category?.id,
	}));
}

export default function OperarioCategoriesPage() {
	const [data, setData] = useState([]);
	const [selectedCategory, setSelectedCategory] = useState(null);
	const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
	const [openEditDialog, setOpenEditDialog] = useState(false);
	const [refresh, setRefresh] = useState(false);

	const loggedUser = useSelector(
		(store) => store.authentication?.user,
		shallowEqual
	);
	const accessToken = loggedUser?.accessToken;

	useEffect(() => {
		getOperarioCategories(accessToken)
			.then((res) => {
				if (res.status === 200) {
					setData(res.data);
					setRefresh(false);
				}
			})
			.catch((error) => {
				alertError({
					error,
					customMessage: "No se han podido obtener las categorías de operario.",
				});
			});
	}, [refresh, accessToken]);

	function buttonFormatter(cell) {
		const category = data.find((item) => item.id === cell);

		return (
			<>
				<Tooltip title="Editar">
					<Button
						style={buttonsStyle}
						size="small"
						onClick={(e) => {
							e.stopPropagation();
							setSelectedCategory(category);
							setOpenEditDialog(true);
						}}
					>
						<EditIcon />
					</Button>
				</Tooltip>
				<Tooltip title="Eliminar">
					<Button
						style={buttonsStyle}
						size="small"
						onClick={(e) => {
							e.stopPropagation();
							setSelectedCategory(category);
							setOpenConfirmDialog(true);
						}}
					>
						<DeleteIcon />
					</Button>
				</Tooltip>
			</>
		);
	}

	const columns = [
		{ dataField: "descripcion", text: "Descripción", sort: true },
		{ dataField: "id", text: "", formatter: buttonFormatter },
	];

	const handleSaveCategory = (category) => {
		const request = category?.id
			? updateOperarioCategory(category.id, category, accessToken)
			: postOperarioCategory(category, accessToken);

		request
			.then((res) => {
				if (res.status === 201 || res.status === 204) {
					alertSuccess({
						title: category?.id ? "¡Guardada!" : "¡Creada!",
						customMessage: category?.id
							? "Categoría de operario actualizada con éxito."
							: "Categoría de operario creada con éxito.",
					});
					setOpenEditDialog(false);
					setSelectedCategory(null);
					setRefresh(true);
				}
			})
			.catch((error) => {
				alertError({
					error,
					customMessage: category?.id
						? "No se ha podido actualizar la categoría de operario."
						: "No se ha podido crear la categoría de operario.",
				});
			});
	};

	return (
		<>
			<Card>
				<CardHeader title="Categorías de operario">
					<CardHeaderToolbar>
						<button
							type="button"
							className="btn btn-primary"
							onClick={() => {
								setSelectedCategory({ id: null, descripcion: "" });
								setOpenEditDialog(true);
							}}
						>
							Nueva categoría
						</button>
					</CardHeaderToolbar>
				</CardHeader>
				<CardBody>
					<Table data={getData(data)} columns={columns} />

					<ConfirmDialog
						title="¿Estás seguro de que quieres eliminar esta categoría de operario?"
						open={openConfirmDialog}
						setOpen={setOpenConfirmDialog}
						onConfirm={() => {
							deleteOperarioCategory(
								selectedCategory?.id,
								accessToken
							)
								.then((res) => {
									if (res.status === 204 || res.status === 200) {
										alertSuccess({
											title: "¡Eliminada!",
											customMessage:
												"Categoría de operario eliminada con éxito.",
										});
										setRefresh(true);
									}
								})
								.catch((error) => {
									alertError({
										error,
										customMessage:
											"No se ha podido eliminar la categoría de operario.",
									});
								});
						}}
					/>

					<EditOperarioCategoryDialog
						title={
							selectedCategory?.id
								? "Editar categoría de operario"
								: "Nueva categoría de operario"
						}
						open={openEditDialog}
						setOpen={setOpenEditDialog}
						data={selectedCategory}
						onSave={handleSaveCategory}
					/>
				</CardBody>
			</Card>
		</>
	);
}
